import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="50" height="50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M25 4.167C13.5 4.167 4.167 13.5 4.167 25 4.167 36.5 13.5 45.833 25 45.833c11.5 0 20.833-9.333 20.833-20.833C45.833 13.5 36.5 4.167 25 4.167zm2.083 31.25h-4.166V31.25h4.166v4.167zm0-8.334h-4.166v-12.5h4.166v12.5z" fill="#FF7D25" /></svg>);